import * as React from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { TimelineInfoStream } from './TimelineInfoStream';
import { MatterSearchField } from '../MatterSearchField';
import { MatterTerminology } from '../../MatterTerminology';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: '25px 18px',
            display: 'inline-block',
            width: '100%',
        },
        searchRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(2),
            paddingBottom: theme.spacing(2.5),
            marginBottom: theme.spacing(2.5),
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        searchField: {
            flex: 1,
            maxWidth: 400,
        },
    })
);

export interface TimelineInfoViewProps {
    id: string;
}

export const RvTimelineInfoView: React.FC<TimelineInfoViewProps> = (props) => {
    const classes = useStyles();
    const [searchQuery, setSearchQuery] = React.useState('');

    return (
        <div className={classes.root}>
            <div className={classes.searchRow}>
                <div className={classes.searchField}>
                    <MatterSearchField
                        hint={MatterTerminology.SearchTimeline}
                        search={searchQuery}
                        searchAction={setSearchQuery}
                        accent="#0F766E"
                    />
                </div>
            </div>
            <TimelineInfoStream
                id={props.id}
                filter={searchQuery}
            />
        </div>
    );
};